import { Point } from '../../type/common.interface';

// 根据比例获取点集中的点
export function getPointByRatio(points: Point[], ratio: number): Point | null {
    if (points.length === 0) {
        return null;
    }
    const index = Math.round(ratio * (points.length - 1));
    return points[index];
}
